<ng-container *ngIf="locations.enabled; else manualAddressHint">
  <app-autocomplete-select
    [formControl]="control"
    [options]="options"
    [searchFn]="search"
    [minSearchLength]="3"
    [selectClass]="selectClass"
    placeholder="Search for a street address">
  </app-autocomplete-select>
  <small class="invalid-feedback d-block" *ngIf="error">{{ error }}</small>
</ng-container>
<ng-template #manualAddressHint>
  <small class="form-hint">Address assistance is unavailable; enter the street details manually.</small>
</ng-template>
